import {Column} from '@ant-design/plots';


interface CustomBarChartProps  {
    data:any[]
}


const BatteryStatus = (props: CustomBarChartProps) => {
    const batteryChartConfig = {
        data: props.data,
        xField: 'field',
        yField: 'value',
        colorField: 'name',
        group: true,
        style: {
            insetLeft: 5,
            insetRight: 5,
        },
        theme: { category10: ['#00B8D9', '#F9CB85'] },
    };

    return (
        <Column {...batteryChartConfig} />
    );
};

export default BatteryStatus;
